import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { useDisplayToken } from '@/domain/hooks/useDisplayToken'
import { Warn } from '@/ui/molecules/warn/Warn'
import { Info } from '@/ui/molecules/info/Info'
interface ActionDetailsProps {
  label: string
  token: Token
  value: NormalizedUnitNumber
  warningText?: string
  infoText?: string
}

export function ActionDetails({ label, token, value, warningText, infoText }: ActionDetailsProps) {
  const displayToken = useDisplayToken(token)
  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-1">
        <p className="text-muted-foreground text-xs leading-none">{label}</p>
        {infoText && <Info>{infoText}</Info>}
        {warningText && <Warn>{warningText}</Warn>}
      </div>
      <p className="text-base">
        {token.format(value, { style: 'auto' })} {displayToken.symbol}
      </p>
      <div className="text-muted-foreground text-xs leading-none">{token.formatUSD(value)}</div>
    </div>
  )
}
